import { useCallback } from 'react'
import { Stack, Button } from '@mui/material'
import { useIsMobile } from '@/hooks/Responsive'
import BoardView from '@components/Board/BoardView'
import { fetchMyCourseNoticeDetail } from '@/api/mypage'

export default function NoticeView({ id, bbsType, onBack }) {
  const { isMobile } = useIsMobile()

  const fetcher = useCallback(async () => {
    if (!id || !bbsType) return Promise.resolve({});
    try {
      const response = await fetchMyCourseNoticeDetail({
      params: { 
        bulletinId: id,
        bbsType: bbsType
      },
    });
      const noticeData = response.data;

      return {
        id: noticeData.bulletinId,
        title: noticeData.bulletinTitle,
        author: noticeData.authorName || '관리자',
        createdAt: noticeData.registDttm,
        views: noticeData.viewCnt || 0,
        content: noticeData.bulletinSubstatnce,
        attachments: noticeData?.noticeAttachFileUrl && ([
          { name: noticeData?.noticeAttachFileName, url: noticeData?.noticeAttachFileUrl }
        ]),
      };
    } catch (error) {
      console.error(`Failed to fetch notice with id ${id}:`, error);
      return {};
    }
  }, [id])

  return (
    <BoardView
      fetcher={fetcher}
      bottomToolbarRender={() => (
        <Stack direction="row" justifyContent="flex-end">
          <Button
            variant="contained"
            size="large"
            sx={{ width: isMobile ? '100%' : 'auto'}}
            onClick={onBack}
          >
            목록
          </Button>
        </Stack>
      )}
    />
  )
}

